module.exports = __webpack_public_path__ + "img/5s2.14388640.jpg";